import {
  BusinessAccountPoliciesDto,
  BusinessAccountPoliciesModel,
  SetBusinessAccountPoliciesArgs,
} from '../types/policies'

export const setBusinessAccountPoliciesArgsToParams = ({
  termsAndConditions,
  returnPolicy,
  additionalInformation,
}: SetBusinessAccountPoliciesArgs): BusinessAccountPoliciesDto => ({
  terms_and_conditions: termsAndConditions,
  return_policy: returnPolicy,
  additional_information: additionalInformation,
})

export const transformBusinessAccountPoliciesDto = (
  policies: BusinessAccountPoliciesDto,
): BusinessAccountPoliciesModel => {
  const { terms_and_conditions, return_policy, additional_information } = policies

  return {
    termsAndConditions: terms_and_conditions,
    returnPolicy: return_policy,
    additionalInformation: additional_information,
  }
}
